import { Button } from '../button'
import { useUserStore } from '~/app/_store/user-store'
import * as React from 'react'
import { useIntercom } from 'react-use-intercom'

export const FeedbackDialog = ({
  label,
  prefill,
}: {
  label?: React.ReactNode
  prefill?: string
}) => {
  const { show, showNewMessage } = useIntercom()
  const optimisticUser = useUserStore((s) => s.optimisticUser)

  const handleFeedbackClick = () => {
    const message =
      prefill ??
      `Hi! I'd like to provide some feedback.

User: ${optimisticUser?.email ?? 'unknown'}
URL: ${window.location.href}

My feedback: `

    // First show the messenger
    show()

    if (message) {
      // Then send the message after messenger is shown
      setTimeout(() => {
        showNewMessage(message)
      }, 750)
    }
  }

  return (
    <Button
      unstyled
      focusStyled
      className="hover:underline cursor-default"
      onClick={handleFeedbackClick}
    >
      {label ?? 'Feedback'}
    </Button>
  )
}
